import VisualSearchButton from './VisualSearchButton'

export default VisualSearchButton
